import { HealthWalletGapReasonType, VisitType, ProcedureType, ProvenanceSource, } from "healthex-common/health.wallet.dtos";
import { format, parseISO } from "date-fns";
import { getObservableT, i18nGetDateFnsLocale } from "../Infra/i18next";
const t = getObservableT("patients");
const PROVENANCE_SOURCE_DISPLAY = {
    [ProvenanceSource.CLINICAL_RECORDS]: () => t("Clinical Records"),
};
export function provenanceSourceDisplay(source) {
    var _a, _b;
    return (_b = (_a = PROVENANCE_SOURCE_DISPLAY[source]) === null || _a === void 0 ? void 0 : _a.call(PROVENANCE_SOURCE_DISPLAY)) !== null && _b !== void 0 ? _b : source;
}
export function safeParse(raw) {
    if (raw === null || raw === "")
        return null;
    if (raw instanceof Date)
        return Number.isNaN(raw.getTime()) ? null : raw;
    const d = parseISO(raw);
    return Number.isNaN(d.getTime()) ? null : d;
}
export function formatDisplayDate(raw) {
    const d = safeParse(raw !== null && raw !== void 0 ? raw : null);
    if (!d)
        return "";
    const locale = i18nGetDateFnsLocale();
    return format(d, "LLL d, yyyy", locale ? { locale } : undefined);
}
export const FILTER_GROUP_VISITS = "visits";
export const FILTER_GROUP_PROCEDURE_DIAGNOSTIC = "procedure-diagnostic";
export const FILTER_ALL = "all";
export var HistoryCategory;
(function (HistoryCategory) {
    HistoryCategory["EMERGENCY"] = "EMERGENCY";
    HistoryCategory["PRIMARY_CARE"] = "PRIMARY_CARE";
    HistoryCategory["SPECIALIST"] = "SPECIALIST";
    HistoryCategory["URGENT_CARE"] = "URGENT_CARE";
    HistoryCategory["ANNUAL_PHYSICAL"] = "ANNUAL_PHYSICAL";
    HistoryCategory["CHIROPRACTIC"] = "CHIROPRACTIC";
    HistoryCategory["ACUPUNCTURE"] = "ACUPUNCTURE";
    HistoryCategory["LAB_DRAW"] = "LAB_DRAW";
    HistoryCategory["IMAGING"] = "IMAGING";
    HistoryCategory["BIOPSY"] = "BIOPSY";
    HistoryCategory["COLONOSCOPY"] = "COLONOSCOPY";
    HistoryCategory["INFUSION"] = "INFUSION";
    HistoryCategory["MINOR_PROCEDURE"] = "MINOR_PROCEDURE";
    HistoryCategory["SURGERY"] = "SURGERY";
    HistoryCategory["VACCINATION"] = "VACCINATION";
    HistoryCategory["GENETIC_TEST"] = "GENETIC_TEST";
    HistoryCategory["SLEEP_STUDY"] = "SLEEP_STUDY";
    HistoryCategory["ALLERGY_TESTING"] = "ALLERGY_TESTING";
    HistoryCategory["CARDIAC_STRESS_TEST"] = "CARDIAC_STRESS_TEST";
    HistoryCategory["PULMONARY_FUNCTION_TEST"] = "PULMONARY_FUNCTION_TEST";
    HistoryCategory["MENTAL_HEALTH"] = "MENTAL_HEALTH";
    HistoryCategory["DENTAL"] = "DENTAL";
    HistoryCategory["VISION"] = "VISION";
    HistoryCategory["OBSTETRICS"] = "OBSTETRICS";
})(HistoryCategory || (HistoryCategory = {}));
export const VISIT_TYPE_TO_CATEGORY = {
    [VisitType.PRIMARY_CARE]: HistoryCategory.PRIMARY_CARE,
    [VisitType.SPECIALIST]: HistoryCategory.SPECIALIST,
    [VisitType.ANNUAL_PHYSICAL]: HistoryCategory.ANNUAL_PHYSICAL,
    [VisitType.URGENT_CARE]: HistoryCategory.URGENT_CARE,
    [VisitType.EMERGENCY]: HistoryCategory.EMERGENCY,
    [VisitType.MENTAL_HEALTH]: HistoryCategory.MENTAL_HEALTH,
    [VisitType.PSYCHIATRY]: HistoryCategory.MENTAL_HEALTH,
    [VisitType.DENTAL]: HistoryCategory.DENTAL,
    [VisitType.VISION]: HistoryCategory.VISION,
    [VisitType.PHYSICAL_THERAPY]: HistoryCategory.CHIROPRACTIC,
    [VisitType.ALTERNATIVE_CARE]: HistoryCategory.ACUPUNCTURE,
    [VisitType.OBSTETRICS]: HistoryCategory.OBSTETRICS,
};
export const PROCEDURE_TYPE_TO_CATEGORY = {
    [ProcedureType.LAB_DRAW]: HistoryCategory.LAB_DRAW,
    [ProcedureType.IMAGING]: HistoryCategory.IMAGING,
    [ProcedureType.BIOPSY]: HistoryCategory.BIOPSY,
    [ProcedureType.COLONOSCOPY_ENDOSCOPY]: HistoryCategory.COLONOSCOPY,
    [ProcedureType.INFUSION]: HistoryCategory.INFUSION,
    [ProcedureType.MINOR_PROCEDURE]: HistoryCategory.MINOR_PROCEDURE,
    [ProcedureType.EVALUATION_AND_MANAGEMENT]: HistoryCategory.MINOR_PROCEDURE,
    [ProcedureType.SURGERY]: HistoryCategory.SURGERY,
    [ProcedureType.VACCINATION]: HistoryCategory.VACCINATION,
    [ProcedureType.GENETIC_TEST]: HistoryCategory.GENETIC_TEST,
    [ProcedureType.SLEEP_STUDY]: HistoryCategory.SLEEP_STUDY,
    [ProcedureType.ALLERGY_TESTING]: HistoryCategory.ALLERGY_TESTING,
    [ProcedureType.CARDIAC_STRESS_TEST]: HistoryCategory.CARDIAC_STRESS_TEST,
    [ProcedureType.PULMONARY_FUNCTION_TEST]: HistoryCategory.PULMONARY_FUNCTION_TEST,
};
export function visitTypeDisplay(visitType) {
    var _a;
    const map = {
        [VisitType.PRIMARY_CARE]: t("Primary Care"),
        [VisitType.SPECIALIST]: t("Specialist"),
        [VisitType.ANNUAL_PHYSICAL]: t("Annual Physical"),
        [VisitType.URGENT_CARE]: t("Urgent Care"),
        [VisitType.EMERGENCY]: t("Emergency"),
        [VisitType.MENTAL_HEALTH]: t("Mental Health"),
        [VisitType.PSYCHIATRY]: t("Psychiatry"),
        [VisitType.DENTAL]: t("Dental"),
        [VisitType.VISION]: t("Vision"),
        [VisitType.PHYSICAL_THERAPY]: t("Physical Therapy"),
        [VisitType.ALTERNATIVE_CARE]: t("Alternative Care"),
        [VisitType.OBSTETRICS]: t("Obstetrics"),
    };
    return (_a = map[visitType]) !== null && _a !== void 0 ? _a : t("Visit");
}
export function procedureTypeDisplay(procedureType) {
    var _a;
    const map = {
        [ProcedureType.LAB_DRAW]: t("Lab Draw"),
        [ProcedureType.IMAGING]: t("Imaging"),
        [ProcedureType.BIOPSY]: t("Biopsy"),
        [ProcedureType.COLONOSCOPY_ENDOSCOPY]: t("Colonoscopy / Endoscopy"),
        [ProcedureType.INFUSION]: t("Infusion"),
        [ProcedureType.MINOR_PROCEDURE]: t("Minor Procedure"),
        [ProcedureType.EVALUATION_AND_MANAGEMENT]: t("Evaluation"),
        [ProcedureType.SURGERY]: t("Surgery"),
        [ProcedureType.VACCINATION]: t("Vaccination"),
        [ProcedureType.GENETIC_TEST]: t("Genetic Test"),
        [ProcedureType.SLEEP_STUDY]: t("Sleep Study"),
        [ProcedureType.ALLERGY_TESTING]: t("Allergy Testing"),
        [ProcedureType.CARDIAC_STRESS_TEST]: t("Cardiac Stress Test"),
        [ProcedureType.PULMONARY_FUNCTION_TEST]: t("Pulmonary Function"),
    };
    return (_a = map[procedureType]) !== null && _a !== void 0 ? _a : t("Procedure");
}
export function buildDismissReasonOptions() {
    return [
        { id: HealthWalletGapReasonType.RECORDS_DIDNT_TRANSFER, label: t("Records didn't transfer") },
        { id: HealthWalletGapReasonType.SAW_DIFFERENT_PROVIDER, label: t("Saw a different provider") },
        { id: HealthWalletGapReasonType.USED_TELEHEALTH, label: t("Used telehealth") },
        { id: HealthWalletGapReasonType.WAS_LIVING_ABROAD, label: t("Was living abroad") },
        { id: HealthWalletGapReasonType.NO_VISITS_DURING_THIS_TIME, label: t("No visits during this time") },
        { id: HealthWalletGapReasonType.SOMETHING_ELSE, label: t("Something else") },
    ];
}
